import React from "react";

import { requestService } from "../services/requestService";
import useFetcher from "@/helpers/hooks/useFetcher";
import { CircularProgress, Typography } from "@mui/material";
import SingleRequestDetail from "./display-brand-request/SingleRequestDetail";
import type { RequestDetailData } from "./display-brand-request/SingleRequestDetail";

type BrandRequestDetailsData = RequestDetailData & {
  brand_request_type?: string;
  system_generated_request_id?: string;
};

type RequestDetailsProps = {
  id: string;
};

function RequestDetails({ id }: RequestDetailsProps) {
  const { data, isLoading } = useFetcher(
    id,
    requestService.getBrandRequestGetById,
    {
      revalidateOnFocus: false,
    }
  );
  const requestData = data as BrandRequestDetailsData | null | undefined;

  if (isLoading)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="primary" />
      </div>
    );

  return (
    <div className="brand-request-details">
      {requestData && Object.keys(requestData).length > 0 ? (
        <SingleRequestDetail
          data={requestData}
          requestType={requestData?.brand_request_type}
          requestId={requestData?.system_generated_request_id}
          isLoading={isLoading}
        />
      ) : (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <Typography variant="h6">No data found</Typography>
        </div>
      )}
    </div>
  );
}

export default RequestDetails;
